import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import getErrorMessageById from 'errors/errors';
import ERROR from 'errors/errorids';
import { showModal, hideModal, resetModal } from 'redux/modules/modal';
import { resetErrorId } from 'redux/modules/error';
import { verifyUserAccount } from 'redux/modules/session';
import PropTypes from 'prop-types';
import { getRoute, ROOT, SUBSCRIPTION } from 'routes';
import AppError from '../../errors/apperror';
import { hidePreloader } from 'redux/modules/preloader';
import { hideChargebeeLoader } from 'redux/modules/chargebeeLoader';
import i18n from 'i18n/i18n';
import { trackUsersLimitReachedOnNonPayingAccount } from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';

const localize = i18n.loc.localize;

const styles = theme => ({
	dialog: {
		'& a': {
			color: theme.palette.colors.alpha,
			'&:hover': {
				textDecoration: 'none'
			}
		}
	},
	content: {},
	actions: {},
	button: {},
});

@withStyles(styles)
class ErrorModal extends Component {

	constructor(props) {
		super();
		this.state = this.getState(props);
	}

	componentWillReceiveProps(props) {
		this.setState(this.getState(props));
	}

	componentDidMount() {
		const { errorId } = this.props.error;
		if (errorId === ERROR.USER_REACHED_THE_COMPANY_INVITATION_LIMIT) {
			trackUsersLimitReachedOnNonPayingAccount(getTrackingOptions(this.props.company));
		}
	}

	getState(props) {
		const { errorId, errorMessage } = props.error;
		// Setting error title, but we don't use it now in UI.
		const { title = localize('error-modal-title'), message, buttons } = getErrorMessageById(errorId);

		return {
			errorId,
			title,
			message: errorMessage || message,
			buttons
		};
	}

	render() {
		const { classes, modalShown } = this.props;
		const { message, buttons, redirectUrl } = this.state;

		if (redirectUrl) {
			return <Redirect to={redirectUrl} />;
		}

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={() => this.resetModal()}
				classes={{
					paper: classes.dialog
				}}>
				<DialogContent>
					<DialogContentText variant='body1' color='default' dangerouslySetInnerHTML={{ __html: message }} />
				</DialogContent>
				{buttons && <DialogActions>
					{buttons.map((button, index) => {
						const type = buttons.length >= 2 && button.close && !button.primary ? 'default' : 'primary';
						return (
							<Button
								key={`button-${index}`}
								variant='contained'
								color={type}
								onClick={() => this.handleButtonClick(button)}
							>
								{button.label}
							</Button>
						);
					})}
				</DialogActions>}
			</Dialog>
		);
	}

	handleButtonClick(button) {
		const { companyId, error: {errorId} } = this.props;

		if (button.close) {
			if (button.redirect)
			{
				if (button.redirect == SUBSCRIPTION) {
					this.setState({
						redirectUrl: getRoute(SUBSCRIPTION, companyId)
					}, () => {
						this.resetModal();
					});
					
				} else {
					window.location.href = button.redirect;
				}
				
				return;
			}

			// To hide <Preloader> screen after error in subscription process:
			// - clear state.errors.errorId flag
			// - clear preloader.loading flag
			// - close modal
			
			this.resetModal();
			this.props.hidePreloader();
			this.props.hideChargebeeLoader();

			return;
		}

		// Special case: need to show confirmation after sending an email
		if (errorId === ERROR.USER_NOT_VALIDATED) {
			return this.handleAccountConfirmationButtonClick();
		}

		return button.onClick;
	}

	handleAccountConfirmationButtonClick() {
		this.props.hideModal();
		this.props.verifyUserAccount().then((data) => {
			if (data instanceof AppError) {
				return;
			}
			this.props.showModal('CONFIRMATION_MODAL', {
				message: localize('error-modal-account-confirmation-message', this.props.currentUserEmail),
				buttons: [
					<Button
						key='button-confirm'
						variant='contained'
						color='primary'
						onClick={() => {
							return <Redirect to={ROOT} />;
						}}
					>
						{localize('continue')}
					</Button>]
			});
		});
	}

	resetModal() {
		this.props.resetErrorId();
		this.props.resetModal();
	}

}

ErrorModal.propTypes = {
	showModal: PropTypes.func,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	resetErrorId: PropTypes.func,
	verifyUserAccount: PropTypes.func,
	classes: PropTypes.object,
	error: PropTypes.object,
	modalShown: PropTypes.bool,
	currentUserEmail: PropTypes.string,
	companyId: PropTypes.string,
	hidePreloader: PropTypes.func,
	hideChargebeeLoader: PropTypes.func,
	company: PropTypes.object,
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	error: state.error,
	modalShown: state.modal.modalShown,
	currentUserEmail: state.session.user && state.session.user.mainEmail,
	companyId: state.companies.selectedId
});

const mapDispatchToProps = dispatch => bindActionCreators({
	showModal,
	hideModal,
	resetModal,
	resetErrorId,
	verifyUserAccount,
	hidePreloader,
	hideChargebeeLoader
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ErrorModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ErrorModal.js